import { render, staticRenderFns } from "./AddBoardContent.vue?vue&type=template&id=0a7552a0"
import script from "./AddBoardContent.vue?vue&type=script&lang=js"
export * from "./AddBoardContent.vue?vue&type=script&lang=js"
import style0 from "./AddBoardContent.vue?vue&type=style&index=0&id=0a7552a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports